import React, { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Context } from '../../..';
import { Certification } from '../../../models/Certification';
import styles from '../CertificationPage.module.scss';

const CertificationEdit: React.FC = () => {
  const { store } = useContext(Context);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const certification = id !== 'new' ? store.certifications.find(cert => cert.id.toString() === id) : null;

  const { register, handleSubmit, formState: { errors }, setValue } = useForm<Certification>({
    defaultValues: certification ?? undefined,
  });

  useEffect(() => {
    if (store.certifications.length === 0) {
      store.getCertifications();
    }
    if (store.user?.role !== 'admin') {
      navigate('/404');
    }
    if (id !== 'new' && !certification) {
      navigate('/404');
    } else if (certification && certification.photo) {
      setValue('photo', certification.photo);
    }
  }, [certification, id, navigate, setValue, store]);

  const onSubmit = async (data: Certification) => {
    let response;
    if (!certification && id === 'new') {
      response = await store.createCertification(data);
    } else if (certification) {
      response = await store.updateCertification(certification.id.toString(), data);
    }
    if (response && response.status === 200) {
      navigate(`/certifications/${response.data.id}`);
    }
  };

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.length) {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        setValue('photo', e.target?.result as string);
      };
      fileReader.readAsDataURL(event.target.files[0]);
    }
  };

  return (
    <form className={styles['certification-form']} onSubmit={handleSubmit(onSubmit)}>
      <div>
        <label className={styles['certification-form__label']} htmlFor="name">Назва:</label>
        <input className={styles['certification-form__input']} {...register('name', { required: 'Це обов`язкове поле' })} id="name" />

        <label className={styles['certification-form__label']} htmlFor="ISO">ISO:</label>
        <input className={styles['certification-form__input']} {...register('ISO', { required: 'Це обов`язкове поле' })} id="ISO" />

        <label className={styles['certification-form__label']} htmlFor="photo">Фото:</label>
        <input className={styles['certification-form__input']} type="file" onChange={onFileChange} accept="image/*" id="photo" />
        {certification && certification.photo && (
          <img src={`${process.env.REACT_APP_BASE_URL}/images/${certification.photo}`} alt="Current" className={styles['certification-form__image']} />
        )}

        <label className={styles['certification-form__label']} htmlFor="description">Опис:</label>
        <textarea className={styles['certification-form__textarea']} {...register('description', { required: 'Це обов`язкове поле' })} id="description" />

        {errors.name && <p className={styles['certification-form__error']}>{errors.name.message}</p>}
        {errors.ISO && <p className={styles['certification-form__error']}>{errors.ISO.message}</p>}
        {errors.photo && <p className={styles['certification-form__error']}>{errors.photo.message}</p>}
        {errors.description && <p className={styles['certification-form__error']}>{errors.description.message}</p>}

        <button className={styles['certification-form__button']} type="submit">Зберегти зміни</button>
        <Link className={styles['certification-form__cancel-link']} to={`/certifications/${id || ''}`}>Скасувати</Link>
      </div>
    </form>
  );
};

export default observer(CertificationEdit);
